import { render, staticRenderFns } from "./AssignShipmentModal.vue?vue&type=template&id=7ed82974&scoped=true"
import script from "./AssignShipmentModal.vue?vue&type=script&lang=js"
export * from "./AssignShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./AssignShipmentModal.vue?vue&type=style&index=0&id=7ed82974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed82974",
  null
  
)

export default component.exports